import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from "./Navbar";

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);
  const toggleMenu = () => setIsMenuOpen((isOpen) => !isOpen);

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  return (
    <>




      <div className="container-fluid sticky-top px-0">
        
        <div className="container-fluid px-0">
          <nav className="navbar navbar-expand-lg navbar-dark pt-0 pb-1 px-4">
            <Link to="/" className="navbar-brand p-0" onClick={closeMenu}>
              <img src="assets/img/Celersoft_Logo.png" alt="Celersoft" />
            </Link>
            <button
              className={`navbar-toggler ${isMenuOpen ? "" : "collapsed"}`}
              type="button"
              aria-controls="navbarCollapse"
              aria-expanded={isMenuOpen}
              aria-label="Toggle navigation"
              onClick={toggleMenu}
            >
              <span className="fa fa-bars" />
            </button>
            <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`} id="navbarCollapse">
              <div className="navbar-nav ms-auto py-0">
                <Navbar onNavigate={closeMenu} />
              </div>
              <div className="d-flex align-items-center flex-nowrap pt-xl-0">
              </div>
            </div>
          </nav>
        </div>
      </div>

      {/* <div
        className="modal fade"
        id="searchModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h4 className="modal-title mb-0" id="exampleModalLabel">
                Search by keyword
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body d-flex align-items-center">
              <div className="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  className="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span id="search-icon-1" className="input-group-text p-3">
                  <i className="fa fa-search" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div> */}

    </>

  );
};

export default Header
